import { Button } from '@/components/Button/Button'
import { GeneratorFormUI } from '@/components/Generator/GeneratorForm/GeneratorFormUI'
import { PostFormUI } from '@/components/Generator/PostForm/PostFormUI'
import { RepoCommitUI } from '@/components/RepoList/RepoCommit/RepoCommitUI'
import { RepoItemUI } from '@/components/RepoList/RepoItem/RepoItemUI'
import GitHubSvg from '@/icons/github.svg?react'
import { results } from '@/pages/Landing/results'
import type { FunctionalComponent } from 'preact'
import { useState } from 'preact/hooks'
import styles from './index.module.scss'

const initialCommits = [
  'Added custom post type feature',
  'Fixed tone and post types',
  'Added tone of voice',
]

export const Landing: FunctionalComponent = () => {
  const [commits, setCommits] = useState(initialCommits.slice(0, 2))
  const [toneId, setToneId] = useState<number>(-2)
  const [postType, setPostType] = useState<number>(-2)

  return (
    <div class={styles.root}>
      <div class={styles.hero}>
        <div class={styles.logo}>gitlog</div>
        <h1 class={styles.title}>Turn commits into X&nbsp;updates</h1>
        <p class={styles.desc}>Generate ready-to-post updates directly from your GitHub commits</p>
      </div>

      <div class={styles.flow}>
        <Button
          type='primary'
          href='/api/auth/github'
          target='_top'
          class={styles.connect}
        >
          <GitHubSvg class={styles.githubSvg} />
          Connect GitHub
        </Button>

        <div class={styles.section}>
          <h2 class={styles.title}>
            1. Select commits
          </h2>
          <RepoItemUI fullName='projects/acme'>
            {initialCommits.map(item => (
              <RepoCommitUI
                message={item}
                selected={commits.includes(item)}
                onToggle={() => {
                  if (commits.includes(item)) {
                    setCommits(commits.filter(it => it !== item))
                  }
                  else {
                    setCommits([...commits, item])
                  }
                }}
              />
            ))}
          </RepoItemUI>
        </div>

        <div class={styles.section}>
          <h2 class={styles.title}>
            2. Choose tone & type
          </h2>
          <div class={styles.form}>
            <GeneratorFormUI
              postType={postType}
              setPostType={setPostType}
              setToneId={setToneId}
              toneId={toneId}
              commits={commits}
              onRemove={commit => {
                if (commits.includes(commit)) {
                  setCommits(commits.filter(it => it !== commit))
                }
                else {
                  setCommits([...commits, commit])
                }
              }}
            />
          </div>
        </div>

        <div class={styles.section}>
          <h2 class={styles.title}>
            3. Get your post
          </h2>
          <div class={styles.form}>
            <PostFormUI
              onChange={() => {}}
              variants={(results as any)[toneId][postType]}
            />
          </div>
        </div>

        <Button
          type='primary'
          href='/api/auth/github'
          target='_top'
          class={styles.connect}
        >
          <GitHubSvg class={styles.githubSvg} />
          Generate a post
        </Button>
      </div>
    </div>
  )
}
